// extracted by mini-css-extract-plugin
export default {"l_TabMenu_main":"TabMenu_l_TabMenu_main__NdC9k"};